var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50016 15H5.8335C3.07183 15 0.833496 12.7617 0.833496 10C0.833496 7.23833 3.07183 5 5.8335 5H7.50016",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H14.1667C16.9283 15 19.1667 12.7617 19.1667 10C19.1667 7.23833 16.9283 5 14.1667 5H12.5",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10H13.3332",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAlt);
export default __webpack_public_path__ + "static/media/link-alt.7248e030a9b705b2983a67ff8745f50f.svg";
export { ForwardRef as ReactComponent };